import { createFileRoute } from "@tanstack/react-router";
import { GlossaryTermDetail } from "@/components/glossary-term-detail";
import { glossaryTermHead } from "@/lib/glossary-seo";

export const Route = createFileRoute("/woordenlijst/$term")({
  head: ({ params }) => glossaryTermHead(params.term, "nl"),
  component: TermPage,
});

function TermPage() {
  const { term } = Route.useParams();
  return <GlossaryTermDetail slug={term} />;
}
